// src/components/ErrorBoundary.js
// One broken page must not blank the whole app. Wrap a page in this and a crash shows a calm message with a way out.
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  // A different page (resetKey changes) starts clean
  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="hms-page">
        <div className="hms-card" style={{ padding: 32, maxWidth: 560, margin: "48px auto", textAlign: "center" }}>
          <div className="hms-summary-title" style={{ marginBottom: 6 }}>
            This page hit a problem
          </div>
          <p className="hms-modal-note" style={{ marginBottom: 20 }}>
            The rest of the system is fine. Try again, and if it keeps happening, tell your administrator what you were doing.
          </p>
          {process.env.NODE_ENV !== "production" && (
            <pre style={{ textAlign: "left", fontSize: 12, whiteSpace: "pre-wrap", color: "#c93c37", marginBottom: 20 }}>
              {String(this.state.error?.message || this.state.error)}
            </pre>
          )}
          <div className="hms-form-actions" style={{ justifyContent: "center" }}>
            <button type="button" className="ant-btn ant-btn-default" onClick={() => this.setState({ error: null })}>
              <span>Try again</span>
            </button>
            <button type="button" className="ant-btn ant-btn-primary" onClick={() => window.location.reload()}>
              <span>Reload page</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
